module.exports = __webpack_public_path__ + "img/qrcode.6b43ee3e.png";